import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { CityInput } from "@/components/elements/CityInput";
import { TMatchForm } from "@/features/match/types/MatchForm";
import { black } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Grid, Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useLocationInfo } from "@/hooks/useLocationInfo";

type TMatchLocationInfoFormProps = {
  defaultValues: Partial<TMatchForm>;
};

export const MatchLocationInfoForm: FCC<TMatchLocationInfoFormProps> = ({ defaultValues: _defaultValues }) => {
  const methods = useFormContext<TMatchForm>();
  const { control } = methods;

  const locationInfo = useLocationInfo({
    methods,
    names: { zipCode: "zipCode", province: "prefecture", municipality: "city", address: "address" },
  });

  return (
    <InnerBox showDivider={false} padding={3}>
      <Stack alignItems="flex-start">
        <Typography variant="head20Bold" color={black[30]}>
          所在地
        </Typography>

        <Grid mt={2} container columnSpacing={3} rowSpacing={1}>
          <Grid item xs={12} sm={6} md={4}>
            <FormField control={control} name="zipCode">
              <Input placeholder="123-4567" />
            </FormField>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormField control={control} name="prefecture">
              <Input readonly />
            </FormField>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <CityInput name="city" control={control} zipCodeFieldName="zipCode" locationInfo={locationInfo} />
          </Grid>
          <Grid item xs={12}>
            <FormField control={control} name="address">
              <Input />
            </FormField>
          </Grid>
        </Grid>
      </Stack>
    </InnerBox>
  );
};
